export const UNIT_OPTIONS = [
    { value: 'KG', text: 'KG' },
    { value: 'L', text: 'L' },
    { value: 'UN', text: 'UN' },
    { value: 'PC', text: 'PC' },
];